<div class="add-charger-container">
  <div class="page-header">
    <div class="title">
      <div class="breadcrumb">
        Dashboard › Chargers › <strong>Add Charger</strong>
      </div>
    </div>

    <div class="actions">
      <button class="btn btn-cancel" (click)="cancel()">Cancel</button>
      <button class="btn btn-save" (click)="saveCharger()">Save</button>
    </div>
  </div><div class="card">
    <div class="card-header">
      <h3 class="card-title">CHARGER INFORMATION</h3>
    </div>

    <div class="card-component">
      <div class="form-grid">

        <!-- Model -->
        <div class="form-group">
          <label>Model</label>
          <select [(ngModel)]="formData.model">
            <option value="" disabled selected hidden>Enter Model</option>
            <option *ngFor="let model of chargerModels" [value]="model.value">
              {{model.label}}
            </option>
          </select>
        </div>

        <!-- Serial Number -->
        <div class="form-group">
          <label>Serial Number</label>
          <input type="text" placeholder="Enter Serial number" [(ngModel)]="formData.serialNumber" />
        </div>

        <!-- Address -->
        <div class="form-group">
          <label>Address Line 1</label>
          <input type="text" placeholder="Enter Address" [(ngModel)]="formData.addressLine1" />
        </div>

        <div class="form-group">
          <label>Address Line 2</label>
          <input type="text" placeholder="Enter Address" [(ngModel)]="formData.addressLine2" />
        </div>

        <!-- City -->
        <div class="form-group">
          <label>City</label>
          <input type="text" placeholder="Enter City Name" [(ngModel)]="formData.city" />
        </div>

        <!-- State -->
        <div class="form-group">
          <label>State</label>
          <select [(ngModel)]="formData.state">
            <option value="" disabled selected hidden>Select State</option>
            <option *ngFor="let state of states" [value]="state">{{state}}</option>
          </select>
        </div>

        <!-- Zip -->
        <div class="form-group">
          <label>Zip Code</label>
          <input type="text" placeholder="Enter Zip Code" [(ngModel)]="formData.zipCode" />
        </div>

        <!-- Country -->
        <div class="form-group">
          <label>Country</label>
          <select [(ngModel)]="formData.country">
            <option value="" disabled selected hidden>Enter Country</option>
            <option value="India">India</option>
          </select>
        </div>

        <!-- Latitude -->
        <div class="form-group">
          <label>Latitude</label>
          <input type="text" placeholder="Enter Latitude" [(ngModel)]="formData.latitude" />
        </div>

        <!-- Longitude -->
        <div class="form-group">
          <label>Longitude</label>
          <input type="text" placeholder="Enter Longitude" [(ngModel)]="formData.longitude" />
        </div>

        <!-- Charger Owner -->
        <div class="form-group">
          <label>Charger Owner</label>
          <select [(ngModel)]="formData.chargerOwnerId">
            <option value="" disabled selected hidden>Select Charger Owner</option>
            <option *ngFor="let owner of chargerOwners" [value]="owner.id">
              {{owner.name}} - {{owner.email}}
            </option>
          </select>
        </div>

        <!-- Tariff Plan -->
        <div class="form-group">
          <label>Choose Tariff Plan</label>
          <select [(ngModel)]="formData.tariffPlanId" (ngModelChange)="onTariffPlanChange($event)">
            <option value="" disabled selected hidden>Select Tariff Plan</option>
            <option *ngFor="let plan of tariffPlans" [value]="plan.id">
              {{plan.name}}
            </option>
          </select>
        </div>

        <!-- Price -->
        <div class="form-group">
          <label>Price Per Kwh</label>
          <div class="display-field">{{pricePerKwh || 'Price'}}</div>
        </div>

        <!-- CGST -->
        <div class="form-group">
          <label>CGST (%)</label>
          <div class="display-field">{{cgst || 'Percentage'}}</div>
        </div>

        <!-- SGST -->
        <div class="form-group">
          <label>SGST (%)</label>
          <div class="display-field">{{sgst || 'Percentage'}}</div>
        </div>

        <!-- IGST -->
        <div class="form-group">
          <label>IGST (%)</label>
          <div class="display-field">{{igst || 'Percentage'}}</div>
        </div>

      </div>
    </div>

  </div>

  <div class="connector-card">

    <!-- Header -->
    <div class="header">
      <h3>CONNECTOR INFORMATION</h3>
      <button class="add-btn" (click)="addConnector()">
        <mat-icon>add_circle</mat-icon>
        Add Connector
      </button>
    </div>

    <!-- Table Header (Always Visible) -->
    <div class="table-header">
      <div>Plug</div>
      <div>Plug Type</div>
      <div></div>
    </div>

    <!-- Rows (Appear after clicking Add Connector) -->
    <div
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
      class="connector-list"
    >
      <div
        class="table-row"
        *ngFor="let connector of connectors; let i = index"
        cdkDrag
      >
        <div class="plug-info">
          <div class="plug-name">{{ connector.plug }}</div>
        </div>
        <div>
          <select [(ngModel)]="connector.plugType">
            <option value="" disabled selected hidden>Select Plug Type</option>
            <option value="Type_6_DC">Type_6_DC</option>
            <option value="GB/T_DC">GB/T_DC</option>
          </select>
        </div>
        <div class="delete">
          <mat-icon (click)="removeConnector(i)">delete</mat-icon>
        </div><!-- Drag handle -->
        <div class="drag-handle" cdkDragHandle>
          <mat-icon>drag_indicator</mat-icon>
        </div>
      </div>
    </div>
  </div>

</div>
